import { UserRoles } from '@/enums';
import { Repairs } from '@/modules/repairs/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Repairs.Pages.REPAIRS]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],
  [Repairs.Pages.NEW_REPAIR]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],
  [Repairs.Pages.REPAIR_DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],
  [Repairs.Pages.WARRANTY_CHECK]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],
  [Repairs.Pages.RETURN_ZIPS]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],
  [Repairs.Pages.EDIT_MAIN_INFO]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],
};

export default access_roles;
